<template>
<div class="foruwizard-step">
  <h1 class="foruwizard-step-header">Как называется ваша компания?</h1>
  <div class="foruwizard-step-content">
    <div class="foruwizard-step-header-small">Укажите компанию <span class="text-negative">*</span></div>
    <div class="form-group foruwizard-form-group foruwizard-form-group-step-1">
      <form autocomplete="off">
        <vue-autosuggest :class="{ inputError: isRed, inputNotEmpty: isNotEmpty }" :suggestions="filteredOptions" :getSuggestionValue="getSuggestionValue" @selected="onSelected" @input="onInputChange" :limit="5" :input-props="inputProps" v-model="company.name">
          <template slot-scope="{ suggestion }">
            <div>
               <b>{{suggestion.item.value}} - {{suggestion.item.data.address.unrestricted_value}}</b>
            </div>
          </template>
        </vue-autosuggest>
      </form>
    </div>
    <div class="form-group foruwizard-form-group-bottom">
      <a href="javascript:void(0)" @click="nextStep()" class="foruwizard-btn-salmon">Далее</a>
    </div>
  </div>
</div>
</template>

<script>
import axios from 'axios';
import { VueAutosuggest } from 'vue-autosuggest';

export default {
  data() {
  console.log("uuuuUUUUUUUUUUUU", this.propObj);
  return {
      isNotEmpty: this.isNotEmpty || false,
      isRed: this.isRed,
      companies: [],
      company: {
        name: this.propObj.data.name,
        address: this.propObj.data.address,
        phone: this.propObj.data.phone,
        category: this.propObj.data.category,
        description: this.propObj.data.description,
        facebook: this.propObj.data.facebook,
        instagram: this.propObj.data.instagram,
        vkontakte: this.propObj.data.vkontakte,
        template_id: this.propObj.data.template_id
      },
      selected: '',
      filteredOptions: [],
      companyname: "",
      inputProps: {
        id: "autosuggest__input"
        // placeholder: "Название компании"
      },
      limit: 10
    }
  },

  components: {
    VueAutosuggest
  },
  props: {
    propObj: {type: Object},
    myNextStep: {type: Function}
  },
  watch:{
    selected: function(){
      console.log("SELECTED");
      console.log(this.selected);
      if(this.selected != {}){
        if(this.selected.data){
          console.warn("SELECTED1");
          this.company.name = this.selected.unrestricted_value;
          this.company.address = this.selected.data.address.value;
          this.$emit("updatecompany", this.company)
        }else{
          console.warn("SELECTED2");
          if(!this.company){
            this.company = {}
          }
          console.log(this);
          this.$emit("updatecompany", this.company)
        }
      }else{
        this.company = {}
        console.log(this.company);
        this.$emit("updatecompany", this.company)
      }
    }
  },
  mounted() {
    console.log("mounted");
    console.log(this.company);
    console.log(this.propObj);
    if (this.company.name === '' || this.company.name === undefined) {
      this.isNotEmpty = false;
    }else{
      this.isNotEmpty = true;
    }
    this.company.email = this.propObj.data.email;
    console.log("AAAAAAAAAAA",this.propObj.data);

  },
  methods: {
    selectName (val) {
      console.log(val);
      this.company.name = val.name || val;
      this.company.address = val.address || "";
      this.company.phone = "";
      this.$emit("updatecompany", this.company);
    },
    nextStep: function(){
      console.log("this.company.name");
      console.log(this.company);
      // if(!this.company.name){
      //   this.$emit("updatecompany", this.company)
      // }
      // this.company.name = this.companyname;
      if(this.company.name != '' && this.company.name != undefined){
        // this.company.name = this.companyname;
        // this.isNotEmpty = true;
        this.myNextStep(2);
      }else{
        this.isRed = true;
        // alert("Укажите название компании");
      }
    },
    checkName: function(value){
      self = this;
      this.$emit('input', value);
      let searchurl = "";
      if(window.location.host.indexOf("localhost") > -1 ) {
        searchurl = 'http://localhost:3000/api/v1/companysearch'
      }else{
        searchurl = 'https://editor.fo.ru/api/v1/companysearch'
      }
      axios
        .post(searchurl, {query: value})

        .then(function (response) {
          let arr = [];
          console.log(response.data.suggestions);
          self.filteredOptions = [{
            data: response.data.suggestions
          }];
        })
    },

    getSuggestionValue(suggestion){
      return suggestion.item.value
    },
    onSelected(option) {
      if(option){
        this.selected = option.item;
        this.$emit('input', option.item.value);
        console.log(this.selected);
      }

    },
    onInputChange(text) {
      console.log(text);
      this.isRed = false;
      this.selected = {};
      this.filteredOptions = [];
      this.company.name = text;
      if (text === '' || text === undefined) {
        this.isNotEmpty = false;
        return;
      }else{
        this.isNotEmpty = true;
      }
      if(text.length < 3){
        return;
      }
      this.checkName(text);
    }

  }
}
</script>

<style lang="scss">

h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
a {
  color: #42b983;
}
.avatar {
  height: 25px;
  width: 25px;
  border-radius: 20px;
  margin-right: 10px;
}

.autosuggest__results-container {
  position: relative;
  width: 100%;
}

.autosuggest__results {
  font-weight: 300;
  margin: 0;
  position: absolute;
  top: 4px;
  z-index: 10000001;
  width: 100%;
  border: 1px solid #e0e0e0;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  background: white;
  padding: 0px;
  max-height: 400px;
  // overflow-y: scroll;
}

.autosuggest__results ul {
  list-style: none;
  padding-left: 0;
  margin: 0;
}

.autosuggest__results .autosuggest__results-item{
  font-family: 'MuseoSansCyrl', sans-serif;
  font-size: 14px;
  font-weight: 100;
  padding: 13px 16px 11px;
  line-height: 15px;
  border-bottom: 1px solid #e2e7ee;
  cursor: pointer;
  color: #4a4a4a;
  b{
    font-weight: 100;
  }
}

.autosuggest__results-item:hover{
  background-color: #f1f4f8;
  cursor: pointer;
}
.autosuggest__results-item:focus{
  background-color:azure;
  cursor: pointer;
}

.autosuggest__results-item--highlighted{
  background-color: azure;
}
#autosuggest ul:nth-child(1) > .autosuggest__results_title {
  border-top: none;
}

.autosuggest__results .autosuggest__results_title {
  color: gray;
  font-size: 11px;
  margin-left: 0;
  padding: 15px 13px 5px;
  border-top: 1px solid lightgray;
}

.autosuggest__results .autosuggest__results_item:active,
.autosuggest__results .autosuggest__results_item:hover,
.autosuggest__results .autosuggest__results_item:focus,
.autosuggest__results
  .autosuggest__results_item.autosuggest__results_item-highlighted {
  background-color: #f6f6f6;
}
// #autosuggest input{
//   margin-bottom: 0;
// }
#autosuggest {
  max-width: 416px;
}


.foruwizard-step{
  text-align: left;
}

.foruwizard-step-header{
  font-family: 'MuseoSansCyrl', sans-serif;
  font-size: 27px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  margin-bottom: 24px;
  letter-spacing: normal;
  color: rgba(29, 29, 29, 0.9);

  @media all and (min-width: 768px){
    font-size: 40px;
    margin-bottom: 56px;
  }
}

.foruwizard-step-descr{
  font-family: 'MuseoSansCyrl', sans-serif;
  font-size: 16px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  margin-bottom: 24px;
  color: rgba(75, 75, 75, 0.9);
  @media all and (min-width: 768px){
    margin-bottom: 56px;
    font-size: 20px;
    line-height: 32px;
  }
}



.foruwizard-step-header-small{
  font-family: 'MuseoSansCyrl', sans-serif;
  font-size: 16px;
  margin-bottom: 8px;
  font-weight: 500;
  color: rgba(74, 74, 74, 0.9);
  @media all and (min-width: 768px){
    font-size: 16px;
    margin-bottom: 8px;
  }
}

.foruwizard-form-group{
  margin-bottom: 24px;
  input:not(.q-field__native){
    border-radius: 4px;
    border: solid 1px #c7c7c7;
    background-color: #ffffff;
    font-family: 'MuseoSansCyrl', sans-serif;
    padding: 13px 16px 11px;
    width: 100%;
    font-weight: 300;
    font-size: 15px;
    @media all and (min-width: 768px){
      padding: 16px;
    }
    &:focus{
      outline: none;
      border-color: #1a3d52;
      color: #1a3d52;
    }
  }
}

// .foruwizard-form-group-bottom{
//   text-align: center;
//   @media all and (min-width: 768px){
//     text-align: left;
//   }
// }

.foruwizard-btn-salmon{
  font-family: 'MuseoSansCyrl', sans-serif;
  background-color: #e88a74;
  color: #fff;
  font-size: 18px;
  font-weight: 300;
  display: inline-block;
  padding: 16px 64px;
  line-height: 24px;
  text-align: center;
  border-radius: 56px;
  &:hover{
    color: #fff;
    text-decoration: none;
  }
  @media all and (min-width: 768px){
    // padding: 16px;
  }
}
.foruwizard-form-group-step-1{
#autosuggest{
  position: relative;
  margin-bottom: 34px;
  #autosuggest__input + .autosuggest__results-container{
    &:before{
      content: "Название компании";
      font-family: 'MuseoSansCyrl', sans-serif;
      font-weight: 300;
      left: 17px;
      right: 0;
      top: -38px;
      color: rgba(0,0,0,0.6);
      font-size: 15px;
      line-height: 20px;
      text-decoration: inherit;
      text-transform: inherit;
      transform-origin: left top;
      position: absolute;
      transition: transform 0.36s cubic-bezier(0.4,0,0.2,1),right 0.36s cubic-bezier(0.4,0,0.2,1);
      pointer-events: none;
    }
  }
  #autosuggest__input:focus{
    line-height: 24px;
    padding-top: 24px;
    padding-bottom: 6px;
    color: #000 !important;
    & + .autosuggest__results-container{
      &:before{
        -webkit-transform: translate3d(0, -40%, 0) scale3d(0.75, 0.75, 0.75);
        transform: translate3d(0, -40%, 0) scale3d(0.75, 0.75, 0.75);
        right: -33.333333%;
        color: currentColor;
      }
    }
  }
  &.inputNotEmpty{
    #autosuggest__input{
      line-height: 24px;
      padding-top: 24px;
      padding-bottom: 6px;
      color: #000 !important;
      & + .autosuggest__results-container{
        &:before{
          -webkit-transform: translate3d(0, -40%, 0) scale3d(0.75, 0.75, 0.75);
          transform: translate3d(0, -40%, 0) scale3d(0.75, 0.75, 0.75);
          right: -33.333333%;
          color: currentColor;
        }
      }
    }
  }
  &.inputError #autosuggest__input{
    border-color: #c10015;
    line-height: 24px;
    padding-top: 24px;
    padding-bottom: 6px;
    color: #000 !important;
    & + .autosuggest__results-container{
      &:before{
        -webkit-transform: translate3d(0, -40%, 0) scale3d(0.75, 0.75, 0.75);
        transform: translate3d(0, -40%, 0) scale3d(0.75, 0.75, 0.75);
        right: -33.333333%;
        color: #c10015;
      }
      &:after{
        content: "Укажите название компании";
        font-family: 'MuseoSansCyrl', sans-serif;
        font-weight: 300;
        color: #c10015;
        font-size: 12px;
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        padding: 8px 18px 0;
        display: block;
        top: 0;
      }
    }
  }
}
}
</style>
